module.exports = __webpack_public_path__ + "static/media/dcg_hero_logo.6b60b210.png";